import { useCallback, useState } from "react";
import StatusToggle from "../forms/StatusToggle";
import NotesField from "../forms/NotesField";
import { useStore } from "../../js/state/store";
import { updateBuyer } from "../../js/api/buyersApi";
import { useAutosave } from "../../js/hooks/useAutosave";
import { useGuestMode } from "../../js/hooks/useGuestMode";
import { TRANSACTION_ITEMS } from "../../pages/buyer/BuyerTransactionChecklist";

export default function BuyerTransactionPanel() {
  const { state, dispatch } = useStore();
  const { canPersist } = useGuestMode();
  const buyer = state.buyer.current;
  const saved = buyer.preferences.transactionChecklist || {};
  const [form, setForm] = useState({
    statuses: saved.statuses || {},
    notes: saved.notes || "",
  });

  const persist = useCallback(
    (next) => {
      if (!canPersist) return;
      dispatch({ type: "UPDATE_PREFERENCES", payload: { transactionChecklist: next } });
      if (buyer.id) {
        updateBuyer(buyer.id, { ...buyer, preferences: { ...buyer.preferences, transactionChecklist: next } });
      }
    },
    [buyer, canPersist, dispatch]
  );

  useAutosave(canPersist ? form : null, persist);

  function setStatus(id, value) {
    setForm((current) => ({
      ...current,
      statuses: { ...current.statuses, [id]: value },
    }));
  }

  return (
    <div className="sidebar-panel">
      <h3 className="sidebar-panel__title">Transaction</h3>
      <p className="muted sidebar-panel__lead">Track financing through closing. This stays in the sidebar.</p>
      {TRANSACTION_ITEMS.map((item, index) => (
        <article key={item.id} className="txn-item" data-tour={index === 0 ? "txn-first" : undefined}>
          <h3>{item.title}</h3>
          <p className="muted">{item.detail}</p>
          <StatusToggle
            name={item.id}
            value={form.statuses[item.id] || ""}
            onChange={(event) => setStatus(item.id, event.target.value)}
          />
        </article>
      ))}
      <NotesField
        label="Transaction notes for my agent"
        name="notes"
        value={form.notes}
        onChange={(event) => setForm((current) => ({ ...current, notes: event.target.value }))}
        placeholder="Lender name, deadlines, or questions before the next milestone."
        rows={4}
      />
    </div>
  );
}
